import { shiftPlanningService } from 'hq/services';
import { useInfiniteQuery } from 'react-query';
import { FirstParamOfFn } from '@types';
import { QUERY_KEYS } from 'api/query-keys';

const useGetShiftPlanningShifts = (
  params: FirstParamOfFn<typeof shiftPlanningService.getShiftPlanningShifts>
) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.shiftPlanningShiftsFilters(params),
    queryFn: async ({ pageParam = 0 }) =>
      await shiftPlanningService.getShiftPlanningShifts({
        pageParam,
        fromDate: params.fromDate,
        pageSizeParam: params.pageSizeParam,
        company: params.company,
        branchOfficeIds: params.branchOfficeIds,
        departmentIds: params.departmentIds,
        jobType: params.jobType,
        filledStatus: params.filledStatus,
        partner: params.partner,
        isFreelance: params.isFreelance,
        isTempWork: params.isTempWork,
        areFreelanceApplications: params.areFreelanceApplications,
        areTempworkApplications: params.areTempworkApplications,
        areNoApplications: params.areNoApplications,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
export { useGetShiftPlanningShifts };
